import React, { useState } from "react";
import { Controller } from "react-hook-form";
//primereact
import { Divider } from "primereact/divider";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";

const PasswordInput = ({ name, label, control, rules, errors, feedback, className, background }) => {
  const [fulfilledRules, setFulfilledRules] = useState({
    upperCase: false,
    lowerCase: false,
    numeric: false,
    specialChar: false,
    minLength: false
  });

  const checkRules = (value) => {
    setFulfilledRules({
      upperCase: /[A-Z]/.test(value),
      lowerCase: /[a-z]/.test(value),
      numeric: /\d/.test(value),
      specialChar: /[@$!%*?&#_+\-=]/.test(value),
      minLength: value.length >= 8
    });
  };

  const handlePasswordChange = (e, field) => {
    const newValue = e.target.value;
    field.onChange(newValue);
    checkRules(newValue);
  };

  const footer = (
    <>
      <Divider />
      <p className="mt-2">Sugestões</p>
      <ul className="pl-2 ms-3 mt-0 line-height-3">
        <li className={fulfilledRules.upperCase ? 'text-strike text-success' : ''}>Ao menos uma letra maiúscula</li>
        <li className={fulfilledRules.lowerCase ? 'text-strike text-success' : ''}>Ao menos uma letra minúscula</li>
        <li className={fulfilledRules.numeric ? 'text-strike text-success' : ''}>Ao menos um caractere numérico</li>
        <li className={fulfilledRules.specialChar ? 'text-strike text-success' : ''}>Ao menos um caractere especial</li>
        <li className={fulfilledRules.minLength ? 'text-strike text-success' : ''}>No mínimo 8 caracteres</li>
      </ul>
    </>
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <>
          <label htmlFor={field.name} className={classNames({ 'p-error': errors[name] })}>
            {label}
          </label>
          <Password
            id={field.name}
            value={field.value || ''}
            onChange={(e) => handlePasswordChange(e, field)}
            inputRef={field.ref}
            inputClassName="w-100 m-0"
            placeholder="Digite a senha"
            promptLabel="Digite sua senha"
            toggleMask
            required
            style={background ? { backgroundColor: "#495057" } : {}}
            className={`w-100  ${className} ${classNames({ 'p-invalid': fieldState.error })}`}
            feedback={feedback}
            strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}[\]|:;'<>,.?/~])(?=.{8,})"
            weakLabel="Fraca"
            mediumLabel="Média"
            strongLabel="Forte"
            footer={footer}
          />
          {errors && errors[name] && (
            <span className="p-error d-flex">{errors[name].message}</span>
          )}
        </>
      )}
    />
  );
};


export default PasswordInput;


// inputClassName="w-100"
// placeholder="Digite a senha"
// promptLabel="Digite sua senha"
// weakLabel="Senha fraca"
// mediumLabel="Pouco Segura"
// strongLabel="Segura"
// required
